<template>
  <div class="ctn" @click="$emit('click', $event)" :class="{item: !isDivider}">
    <div :class="{divider: isDivider}"><slot></slot></div>
    <div class="hot-key" v-if="!isDivider">{{ hotKey }}</div>
  </div>
</template>

<script>
export default {
  name: "ctxMenuItem",
  props: {
    hotKey: String,
    isDivider: Boolean
  }
}
</script>

<style scoped>
.ctn {
  color: #bbb;
  line-height: 32px;
  user-select: none;
  padding: 0 1em;

  display: flex;
  justify-content: space-between;

  white-space: nowrap;
}
.ctn:hover {
  cursor: default;
}
.item:hover {
  color: #fff;
  background-color: #3c3c3c;
}
.hot-key {
  color: #777;
  font-size: 0.8em;
  margin-left: 2em;
}
.divider {
  height: 13px;
  width: 100%;
  margin-bottom: 12px;
  border-bottom: 1px solid #919191;
}
</style>
